exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sk-wave .sk-rect {\n  background-color: #fff !important; }\n", "", {"version":3,"sources":["/app/src/assets/sass/plugins/spinkit.sass"],"names":[],"mappings":"AAAA;EACE,kCAAkC,EAAE","file":"spinkit.sass","sourcesContent":[".sk-wave .sk-rect {\n  background-color: #fff !important; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./src/assets/sass/plugins/spinkit.sass
// module id = ./node_modules/css-loader/index.js??ref--4-1!./node_modules/postcss-loader/lib/index.js??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./src/assets/sass/plugins/spinkit.sass
// module chunks = 33